import React from "react";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";

export default function Title(props) {
	const theme = useTheme();
	const isDark = theme.palette.type === "dark";

	return (
		<Typography 
			variant="h5" 
			style={{ 
				color: isDark ? "#FFFFFF" : theme.palette.primary.main, 
				fontWeight: 700,
				letterSpacing: "-0.5px",
				margin: 0,
				...props.style
			}}
		>
			{props.children}
		</Typography>
	);
}
